import { JobFamilies, JobType } from "../../DTOs/apiEnums.generated";

// Note: these mirror JobFamilies.ParentOf and JobFamilies.Covering on the server, so a change to either has to be made in both.
export const jobFamilyParent = (jobType: number): JobType | null =>
  (jobType & JobFamilies.BlastHoleDrilling) !== 0 && jobType !== JobType.BlastHoleDrilling ? JobType.BlastHoleDrilling : null;

export const jobFamilyCovering = (jobTypes: number): number =>
  (jobTypes & JobType.BlastHoleDrilling) !== 0 ? jobTypes | JobFamilies.BlastHoleDrilling : jobTypes;
